import { PATH_URL } from "@/constants";
import ApiInstance from "./axiosBase";
import { toParams } from "@/utils/ObjectUtils";

export const AdminCreateSetting = (body: any) => {
  return ApiInstance.post(`${PATH_URL.SETTING}/create`, body);
};

export const AdminUpdateSetting = (body: any) => {
  return ApiInstance.put(`${PATH_URL.SETTING}/update`, body);
}

export const AdminGetDetailSetting = (query: any) => {
  const params = toParams(query);
  return ApiInstance.get(`${PATH_URL.SETTING}/detail` + params);
}
